const getTotalSegments = leagueSlug => {
  switch (leagueSlug) {
    case 'nhl':
      return 3;
    case 'mlb':
      return 9;
    case 'ncaab':
    case 'epl':
      return 2;
    case 'nba':
    case 'nfl':
    default:
      return 4;
  }
};

export default getTotalSegments;
